import React, { useEffect, useCallback } from 'react';
import { Prompt, useHistory } from 'react-router';
import PropTypes from 'prop-types';

const UnsavedChanges = ({ 
  dirty, 
  message = 'You have unsaved changes, are you sure you want to leave?',
  ignoreHashChanges = true 
}) => {
  const history = useHistory();

  // Custom message handler that can ignore hash changes
  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      // If we're ignoring hash changes and the only difference is the hash, allow the navigation
      if (ignoreHashChanges) {
        const currentPath = history.location.pathname;
        const nextPath = nextLocation.pathname;
        
        // If only the hash is changing, allow the navigation without prompting
        if (currentPath === nextPath) {
          return true;
        }
      }
      
      // Otherwise show the prompt
      return message;
    },
    [history, ignoreHashChanges, message]
  );

  // Must track when dirty changes and update the onbeforeunload
  // for window. This prevents user from refreshing/exiting page when
  // changes are unsaved.
  useEffect(() => {
    if (window) {
      window.onbeforeunload = dirty ? () => true : undefined;

      return () => {
        window.onbeforeunload = undefined;
      };
    }
  }, [dirty]);

  return <Prompt when={dirty} message={handleBlockedNavigation} />;
};

UnsavedChanges.propTypes = {
  dirty: PropTypes.bool.isRequired,
  message: PropTypes.string,
  ignoreHashChanges: PropTypes.bool
};

export default UnsavedChanges;
